import React from "react";
import "./css/randomCard.css";

function RandomCard({ heading, para, onCardClick }) {
  return (
    <div className="item-card" onClick={() => onCardClick(heading)}>
      <div className="card-content">
        <h3 className="card-heading">{heading}</h3>
        <p className="card-para">{para}</p>
      </div>
      <div className="card-arrow">→</div>
    </div>
  );
}

export default RandomCard;
